import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@patternfly/react-core';

import '../styles.scss';
import useMobxStores from 'hooks/useMobxStores';

const NoEnrollment = () => {
  const { t } = useTranslation();
  const { userStore } = useMobxStores();

  return (
    <React.Fragment>
      <div className="no-enrollment-found" data-testid="no-enrollment-found">
        <Alert
          variant="warning"
          className="lab_alert"
          isInline
          title={t('No enrollment found ({{username}})', {
            username: userStore.user?.username,
          })}
        >
          <p>
            {t(
              'You have logged in using a Red Hat account ID that is not enrolled in Red Hat Training. Please ensure you log in with the correct Red Hat account ID that was provided a Red Hat Training enrollment. For technical support click the Support link at the top of the page, and fill out the form.',
            )}
          </p>
        </Alert>
      </div>
    </React.Fragment>
  );
};

export default observer(NoEnrollment);
